export default {
  // ========== Tooltips ==========
  clearContent: 'Clear Content',

  // ========== Modal titles ==========
  createTitle: 'Create title',
  editTitle: 'Edit title',

  // ========== Form ==========
  title: 'Title',
  default: 'Default',
  saveTitle: 'Save Title',

  // ========== Buttons ==========
  addDescriptor: 'Add Descriptor',
  attachments: 'Attachments',

  // ========== Informative texts ==========
  descriptionOf: 'Description of the',
  hiddenInNormalView: 'Hidden in normal view',

  // ========== Confirmations ==========
  editDescriptorConfirm: 'Are you sure you want to edit the Descriptor?',
  affectOthersWarning: 'This could affect other {entity}!',
  necessaryObjectWarning: 'This object is necessary for the functioning of the teaching kit.',

  // ========== Copy Descriptors ==========
  copyDescriptorsToEpm: 'Copy to the {entity} of another {entity2}',
  copyDescriptorsFromEpm: 'Copy from the {entity} of another {entity2}',
  copyDescriptorsToMatter: 'Copy to {entityMatter}',
  copyDescriptorsFromMatter: 'Copy from {entityMatter}',
  copyDescriptors: 'Copy Descriptors',
  copyDescriptorsConfirm: 'Are you sure you want to copy the descriptors? The current descriptors of the destination will be deleted and replaced. This action cannot be undone.',
  copyDescriptorsSuccess: 'Descriptors copied successfully.',
  copyDescriptorsError: 'An error occurred while copying the descriptors.',
  copyEpmToEpmDescriptorsDesc: 'The descriptors of this {entity} will be copied to the {entity} of the other {entityProfile} you select. The current descriptors of the destination will be deleted and replaced by those of this {entity}. <strong>Requirement:</strong> both {entity} must have the "Link Base Subject" option set to <strong>No</strong>.',
  copyEpmFromEpmDescriptorsDesc: 'The descriptors of the selected source {entity} will be copied to this {entity}. The current descriptors of this {entity} will be deleted and replaced. <strong>Requirement:</strong> both {entity} must have the "Link Base Subject" option set to <strong>No</strong>.',
  copyEpmToMatterDescriptorsDesc: 'The descriptors of this {entity} will be copied to the base {entityMatter}. This will affect all {entityEpm} linked to this {entityMatter}.',
  copyMatterToEpmDescriptorsDesc: 'The descriptors of the base {entityMatter} will be copied to this {entity}, replacing the current descriptors.',
  descriptorsToBecopied: 'Descriptors to copy',
  descriptorsToBeReplaced: 'Descriptors to be replaced',
  noDescriptorsInSource: 'No descriptors in source.',
  noDescriptorsInTarget: 'No descriptors in target.',
  loadingDescriptors: 'Loading descriptors...',
  noContent: 'No content',
  sourceLabel: 'Source',
  targetLabel: 'Target',
  selectTargetEpm: 'Select the target {entity}',
  selectSourceEpm: 'Select the source {entity}',
  sectionTop: 'Descriptors from the top section.',
  sectionBottom: 'Descriptors from the bottom section.',
  sectionMiddle: 'Descriptors between the learning outcomes and the evaluations.',
  sectionAfterEvaluations: 'Descriptors after the evaluations.',
  sectionAfterLearningEnv: 'Descriptors after the learning environment resources.',

  // ========== Sort Descriptors ==========
  dropZoneHint: 'Drag a descriptor from another section here',
}
